import axios from 'axios'
import { getToken } from './auth'
import apiEnv from '@/api/env'

// 通用文件流导出（Blob 下载）
export function exportFile ({ url, data, method = 'post', defaultFileName = '导出文件.xlsx' }) {
  const token = getToken()
  const params = method === 'get' ? { params: data } : { data }

  return axios({
    url: apiEnv.baseURL + url,
    method,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      usernmequityagent: token || ''
    },
    ...params
  }).then(response => {
    // 从 Content-Disposition 解析文件名
    const disposition = response.headers['content-disposition']
    let fileName = defaultFileName
    if (disposition) {
      const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;\n]+)/i)
      if (match) {
        fileName = decodeURIComponent(match[1].replace(/['"]/g, ''))
      }
    }

    const blob = new Blob([response.data])
    const link = document.createElement('a')
    link.href = URL.createObjectURL(blob)
    link.download = fileName
    link.click()
    URL.revokeObjectURL(link.href)
  })
}
